module.exports = "pegasus/assets/time-card.png";